// File: src/pages/AdminFeedbackSection.jsx
import React, { useContext, useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper } from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import { createAuthenticatedAPI } from '../utils/apiClient';

const AdminFeedbackSection = () => {
  const { user, logout } = useContext(AuthContext);
  const api = createAuthenticatedAPI({ user, logout });
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await api.get('/feedback/admin');
        setRows(data || []);
      } catch (e) {
        setRows([]);
      }
    };
    load();
  }, []);

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Recent Feedback</Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Page</TableCell>
                <TableCell>User</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} hover>
                  <TableCell>{new Date(r.timestamp).toLocaleString()}</TableCell>
                  <TableCell>{r.type}</TableCell>
                  <TableCell>{r.message}</TableCell>
                  <TableCell sx={{ maxWidth: 240, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.page}</TableCell>
                  <TableCell>{r.user_id ?? '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default AdminFeedbackSection;


